import { composeIO } from 'react-compose-io'
import { fieldsSubstituirTransformacaoApiIO } from './FieldsSubstituirTransformacaoApi.IO'
import { FieldsSubstituirTransformacaoApiView } from './FieldsSubstituirTransformacaoApi.View'

export const FieldsSubstituirTransformacaoApi = composeIO(FieldsSubstituirTransformacaoApiView, fieldsSubstituirTransformacaoApiIO)
